import React from "react";

import { Button } from "@/components/form/Button/Button";

import { useSearchPageContext } from "../context";

export const LadiesEmptyState: React.FC = () => {
  const { submitToSearchParamsContext } = useSearchPageContext();

  return (
    <div className="flex flex-col gap-2 justify-center items-center">
      <h2 className="font-bold text-pink">No results</h2>
      <Button onClick={() => submitToSearchParamsContext({})}>
        Reset filters
      </Button>
    </div>
  );
};
